import { render, staticRenderFns } from "./randomButton.vue?vue&type=template&id=a728c9a4&scoped=true&"
import script from "./randomButton.vue?vue&type=script&lang=js&"
export * from "./randomButton.vue?vue&type=script&lang=js&"
import style0 from "./randomButton.vue?vue&type=style&index=0&id=a728c9a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a728c9a4",
  null
  
)

export default component.exports